export const isTenantVet = (): boolean => {
  return import.meta.env.VITE_TENANT && import.meta.env.VITE_TENANT?.toUpperCase() === "VET" ? true : false;
};

const exportObj = {
  isTenantVet,
};

export default exportObj;
